module.exports = __webpack_public_path__ + "static/media/Pic1.f19b48a6.png";